export const CREDIT_CARD_STATUS = {
  INITIAL: 'INITIAL',
  SUCCESS: 'SUCCESS', // for bind card result
  SUCCESSED: 'SUCCESSED', // for getCreditCardList
  LOADING: 'LOADING',
  FAIL: 'FAIL',
};

export const QUERY_POLLING_ID = 'polling_id';
export const LOCAL_STORAGE_WEBHOOK_ID = 'payment_instrument_webhook_map';
